<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="recruitPage">
            <div class="aboutKYArea">
                <div class="bannerArea">
                    <div class="banner">
                        <h1>
                            We're Hiring !
                            <br />
                            致力於打造新世代科技應用的人才
                        </h1>
                        <p>
                            坤侑科技致力於專業、品質、創新，不僅是技術的殿堂，更是夢想的孵化器!
                            <br />
                            你將與最優秀的工程師、設計師和專案經理等優秀人才共事，挑戰業界極限、開啟職業巔峰。
                            <br />
                            不論你是技術專家還是充滿熱情的新手，我們都歡迎你的加入，一起成就不凡之旅！
                        </p>
                    </div>
                </div>
            </div>

            <div class="resumeArea">
                <div class="resumeBox">
                    <p>立即投遞履歷，加入頂尖團隊</p>
                    <button
                        class="vacancies-btn"
                        (click)="open104Web()">
                        <span>查看職缺</span>
                    </button>
                </div>
            </div>

            <div class="welfareArea">
                <div class="welfareAreaBox">
                    <div class="titleBox">
                        <p>加入坤侑的專屬福利</p>
                    </div>
                    <div class="welfareBox">
                        <div class="welfareCard">
                            <span>
                                <img
                                    src="/assets/images/recruitPages/recruit-environment.png"
                                    alt="" />
                            </span>
                            <div class="textBox">
                                <p class="welfareTitle">完善制度與環境</p>
                                <div class="welfareContent">
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        提供彈性30分鐘上下班
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        提供年度免費健康檢查
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        提供教育訓練考證補助
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        友善多元的職場空間
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="welfareCard">
                            <span>
                                <img
                                    src="/assets/images/recruitPages/recruit-bonus.png"
                                    alt="" />
                            </span>
                            <div class="textBox">
                                <p class="welfareTitle">優渥薪資及獎金</p>
                                <div class="welfareContent">
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        保障年終2個月
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        年度不定額普調
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        享有生日禮金
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        享有三節獎金或禮品
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        依工作表現發放績效獎金
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        內部引薦優秀人才的推薦獎金
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="welfareCard">
                            <span>
                                <img
                                    src="/assets/images/recruitPages/recruit-vacation.png"
                                    alt="" />
                            </span>
                            <div class="textBox">
                                <p class="welfareTitle">豐富活動與假期</p>
                                <div class="welfareContent">
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        每年2天有薪病假
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        每年3天有薪事假
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        女性員工每月1天有薪生理假
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        不定期員工旅遊
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"></i>
                                        節慶活動及年度尾牙晚會
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="careerArea">
                <div class="careerAreaBox">
                    <div class="titleBox">
                        <p>我們重視每位員工的職涯發展和自我成長</p>
                    </div>
                    <div class="careerBox">
                        <div class="careerCard">
                            <div class="textBox">
                                <p class="careerTitle">內訓</p>
                                <p class="careerSubTitle">
                                    掌握未來，由內部開始
                                </p>
                                <div class="careerContent">
                                    <p>
                                        為團隊提供量身訂做的教育訓練，透過專業導師的引導，協助團隊培養新技能、擴展知識面。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="careerCard">
                            <div class="textBox">
                                <p class="careerTitle">外訓</p>
                                <p class="careerSubTitle">迎接挑戰，超越極限</p>
                                <div class="careerContent">
                                    <p>
                                        透過豐富多元的外訓課程，與來自不同行業的專家互動，深化專業知識。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="jobArea">
                <div class="jobAreaBox">
                    <div class="titleBox">
                        <p>探索各種職務</p>
                    </div>
                    <div class="jobBox">
                        <div
                            class="jobCard"
                            [ngStyle]="{
                                'background-image':
                                    'url(' +
                                    '/assets/images/recruitPages/job-1.png' +
                                    ')'
                            }">
                            <div class="jobTitleBoxInfo">
                                <p class="jobTitle jobTitleInfo">資訊工程</p>
                            </div>
                            <div class="jobContent">
                                <p>前/後端工程師</p>
                                <p>AI工程師</p>
                                <p>APP工程師</p>
                                <p>UI/UX設計師</p>
                            </div>
                        </div>

                        <div
                            class="jobCard"
                            [ngStyle]="{
                                'background-image':
                                    'url(' +
                                    '/assets/images/recruitPages/job-2.png' +
                                    ')'
                            }">
                            <div class="jobTitleBoxBusiness">
                                <p class="jobTitle jobTitleBusiness">
                                    商務開發
                                </p>
                            </div>
                            <div class="jobContent">
                                <p>業務經理</p>
                                <p>技術顧問</p>
                                <p>售前規劃顧問</p>
                            </div>
                        </div>
                        <div
                            class="jobCard"
                            [ngStyle]="{
                                'background-image':
                                    'url(' +
                                    '/assets/images/recruitPages/job-3.png' +
                                    ')'
                            }">
                            <div class="jobTitleBoxSystem">
                                <p class="jobTitle jobTitleSystem">系統維運</p>
                            </div>
                            <div class="jobContent">
                                <p>維運工程師</p>
                                <p>DevOps工程師</p>
                                <p>系統分析/架構師</p>
                                <p>資料庫管理人員</p>
                            </div>
                        </div>
                        <div
                            class="jobCard"
                            [ngStyle]="{
                                'background-image':
                                    'url(' +
                                    '/assets/images/recruitPages/job-4.png' +
                                    ')'
                            }">
                            <div class="jobTitleBoxProject">
                                <p class="jobTitle jobTitleProject">專案管理</p>
                            </div>
                            <div class="jobContent">
                                <p>技術專案經理</p>
                                <p>專案經理</p>
                                <p>專案助理</p>
                            </div>
                        </div>
                        <div
                            class="jobCard"
                            [ngStyle]="{
                                'background-image':
                                    'url(' +
                                    '/assets/images/recruitPages/job-5.png' +
                                    ')'
                            }">
                            <div class="jobTitleBoxAdmin">
                                <p class="jobTitle jobTitleAdmin">行政營運</p>
                            </div>
                            <div class="jobContent">
                                <p>行政總務</p>
                                <p>會計人員</p>
                                <p>採購人員</p>
                                <p>人力資源管理師</p>
                            </div>
                        </div>
                    </div>
                    <div class="footerBox">
                        <button
                            class="vacancies-btn"
                            (click)="open104Web()">
                            <span>查看職缺</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
